import React, { useEffect, useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setUserDetails, logout } from "../Store/Userslice";
import { apiService } from "../../services/api";

const Dashboard = () => {
  const user = useSelector(state => state.user);
  const dispatch = useDispatch();
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);
  
  console.log("Dashboard user:", user);

  useEffect(() => {
    const verifyAuthentication = async () => {
      try {
        setIsCheckingAuth(true);
        
        // Test backend connection first
        const isBackendConnected = await apiService.testConnection();
        if (!isBackendConnected) {
          console.error('Backend is not accessible');
          return;
        }

        // Verify user authentication with backend
        if (!user?._id) {
          const authResult = await apiService.checkAuth();
          console.log('Auth check result:', authResult);
          
          if (authResult.isAuthenticated && authResult.user) {
            dispatch(setUserDetails(authResult.user));
          } else {
            dispatch(logout());
          }
        }
      } catch (error) {
        console.error('Authentication verification failed:', error);
        if (error.status === 401) {
          dispatch(logout());
        }
      } finally {
        setIsCheckingAuth(false);
      }
    };

    verifyAuthentication();
  }, [user, dispatch]);

  // Show loading while checking authentication
  if (isCheckingAuth) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-4 border-blue-500 border-t-transparent mx-auto mb-4"></div>
          <p className="text-gray-700 text-lg font-medium">Checking authentication...</p>
          <p className="text-gray-500 text-sm mt-2">Please wait while we verify your session</p>
        </div>
      </div>
    );
  }

  // Check if user is authenticated
  if (!user?._id) {
    return <Navigate to="/login" replace />;
  }

  return (
    <section className="bg-gradient-to-br from-gray-50 to-blue-50 min-h-screen w-full overflow-x-hidden">
      {/* No sidebar or mobile menu - completely removed */}
      
      {/* Main Content Area */}
      <div className="w-full max-w-full mx-auto">
        <div className="min-h-screen">
          {/* Main content - full width without sidebar */}
          <main className="w-full max-w-full overflow-x-hidden">
            <div className="p-4 sm:p-6 lg:p-8 w-full max-w-full">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </section>
  );
};

export default Dashboard;